import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.437 7.81a.617.617 0 0 1 0 .873l-2.7 2.7h6.016a.617.617 0 0 1 0 1.234H9.737l2.7 2.7a.617.617 0 0 1-.873.873L7.81 12.436a.617.617 0 0 1 0-.873l3.753-3.753a.617.617 0 0 1 .873 0Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8.765a8.765 8.765 0 1 0 0 17.53 8.765 8.765 0 0 0 0-17.53Z"
      clip-rule="evenodd"
    />
  </svg>
`;
